import client from '@/api/client'
import { ScorecardEntity } from '@/entities/scorecard'
import { OfflineCache } from '@/mobile/src/utils/offlinecache'
import { IScorecardTopic } from '@/pages/appstore/components/Scorecard/scorecard-settings-entity'

const offlineCache = new OfflineCache('scorecard')

export async function getScorecard(userId?: string) {
    return offlineCache.cachedGet<ScorecardEntity>(client, `/scorecard` + (userId ? `/user/${userId}` : ``))
}

export async function getScorecardTopics() {
    return await client.get<IScorecardTopic>(`/scorecard-settings/topics`)
}

export async function getMyTeam() {
    return offlineCache.cachedGet(client, `/scorecard/my-team`)
}

export async function getBadgeTotalCount(badge: string, type: string, userId?: string) {
    badge = encodeURIComponent(badge)
    const t = type === 'positive' ? 1 : -1
    return offlineCache.cachedGet(client, `/scorecard/badge/`+ (userId ? `user/${userId}/` : ``) + `${t}/${badge}/total`)
}

export async function seeBadge(badge: string, type: string) {
    badge = encodeURIComponent(badge)
    const t = type === 'positive' ? 1 : -1
    return client.post(`/scorecard/badge/${t}/${badge}/see`, {})
}

export async function finishTour() {
    return client.post(`/scorecard/finish-tour`, {})
}

export async function loadScorecardStats(weekNumberBefore: number) {
    return client.get(`/scorecard/stats/${weekNumberBefore}`)
}

export async function loadScorecardResponseRates(months: number) {
    return client.get(`/scorecard/response-rates/${months}`)
}
